import React, {Component} from 'react';
import PropTypes from 'prop-types';


import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import { ListItemButton } from '@mui/material';

const s:any = {
  itemicon: {
    minWidth: 34,
    color: '#5B6160',
  }
};

class DynamicMenuItem extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  
  state = {
    open: this.props.openImmediately,
  };

  componentDidMount() {
    // So we only run this logic once.
    if (!this.props.openImmediately) {
      return;
    }

    // Center the selected item in the list container.
    const activeElement = document.querySelector(`.${this.props.classes.active}`);
    if (activeElement && activeElement.scrollIntoView) {
      activeElement.scrollIntoView({});
    }
  }

  render() {
    const {
      children,
      classes,
      icon,
      index,
      action,
      onClick,
      openImmediately,
      title,
      ...other
    } = this.props;

    const {activeid} = this.props;
    const active = (index === activeid);

    var menuicon = React.isValidElement(icon) ? icon : (<MenuIcon />);

    return ( 
      <ListItem onClick={onClick(null,action,index)} {...other} disablePadding sx={{ display: 'block' }}>
        <ListItemButton 
          selected={active}
          sx={{
            minHeight: 50,
            mx: 1,
            my: 0.2,
            px: 1.5,
            borderRadius: '9px',
            color: '#454A49',
            '&:hover': {
              bgcolor: '#FFF5EB',
              color: '#923A00',
              '& .MuiListItemIcon-root': { color: '#D65E00' },
            },
            '&.Mui-selected': {
              bgcolor: '#FFE5C7',
              color: '#923A00',
              '& .MuiListItemIcon-root': { color: '#D65E00' },
            },
            '&.Mui-selected:hover': {
              bgcolor: '#FFDBAF',
            },
          }}>
        <ListItemIcon sx={{...s.itemicon}}>
          {React.cloneElement(menuicon, { sx: { fontSize: 21 } })}
        </ListItemIcon>
        <ListItemText
          primary={title}
          primaryTypographyProps={{ fontSize: 14, fontWeight: 650, noWrap: true }}
        />
        </ListItemButton>
      </ListItem>
    );
  }
}

DynamicMenuItem.propTypes = {
  //classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  openImmediately: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

DynamicMenuItem.defaultProps = {
  openImmediately: false,
};

export default DynamicMenuItem;
